import React from 'react';
import HeaderProfile from '../Components/HeaderProfile'


const OrganizationProfile = () => (
    <>
        <HeaderProfile></HeaderProfile>
        <div className="toolbar py-2" id="kt_toolbar">
            <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                <div className="flex-grow-1 flex-shrink-0 me-5">
                    <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                        <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">My Profile</h1>
                        <span className="h-20px border-gray-200 border-start mx-3"></span>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                            <li className="breadcrumb-item">
                                <a href="/Settings/Myprofile" className="text-muted text-hover-primary">Organization Profile</a>
                            </li>

                        </ul>
                    </div>
                </div>
                <div class="d-flex align-items-center flex-wrap">


                    <div class="flex-shrink-0">
                        <ul class="nav" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a href='/settings'>
                                    <img src='/assets/images/back.png' className="imgBack" /> </a>
                            </li>


                        </ul>
                    </div>


                </div>

            </div>
        </div>

        <section className='wraper'>
            <div className='box_shadow mt-14'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h3 className='headings'>Organization Profile</h3>
                    </div>
                    <div class="col-md-3">
                        <label className='required'>Billing Entity</label>
                        <input class="form-control form-control-solid" type="text" name="" />
                    </div>

                    <div class="col-md-3">
                        <label>Employee ID</label>
                        <input class="form-control form-control-solid" type="text" name="" />
                    </div>

                    <div class="col-md-3">
                        <label>Designation</label>
                        <input class="form-control form-control-solid" type="text" name="" />
                    </div>

                    <div class="col-md-3">
                        <label>Band</label>
                        <input class="form-control form-control-solid" type="text" name="" />
                    </div>

                    <div class="col-md-3">
                        <label>Date of Joining</label>
                        <input class="form-control form-control-solid" type="date" name="" />
                    </div>

                    <div class="col-md-3">
                        <label>Work Location</label>
                        <input class="form-control form-control-solid" type="text" name="" />
                    </div>

                    <div class="col-md-3">
                        <label>Department</label>
                        <input class="form-control form-control-solid" type="text" name="" />
                    </div>

                    <div class="col-md-3">
                        <label>Cost Center</label>
                        <input class="form-control form-control-solid" type="text" name="" />
                    </div>

                    <div class="col-md-3">
                        <label>Date of Birth</label>
                        <input class="form-control form-control-solid" type="text" name="" />
                    </div>

                    <div class="col-md-3">
                        <label>Reporting Manager</label>
                        <input class="form-control form-control-solid" type="text" name="" />
                    </div>

                    <div class="col-md-3">
                        <label>System Intrgration Ref No</label>
                        <input class="form-control form-control-solid" type="text" name="" />
                    </div>

                    <div class="col-md-3">
                        <label>Role</label>
                        <input class="form-control form-control-solid" type="text" name="" />
                    </div>



                    <div class="col-md-3">
                        <label>Employee Type</label>
                        <select class="form-select form-select-solid">
                            <option value="Success">Permanent</option>
                            <option value="Success">Payrole</option>
                        </select>
                    </div>
                    <div class="col-md-12 text-end">
                        {/* <button className='btn btn-primary m-1'>Save</button> */}
                        <button className='btn btn-primary m-1'>Update</button>
                    </div>


                </div>

            </div>
        </section>
    </>

);

export default OrganizationProfile;
